import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';


function formatDateTime(dateStr) {
  const date = new Date(dateStr); 
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Singapore'
  }).format(date);
}


const DayWisePowerSensorChart = () => {
  const [latestData, setLatestData] = useState([]);
  const [loading, setLoading] = useState(false);
  const plants = ['SLS', 'Sweelee'];

  const fetchLatestData = async () => {
    setLoading(true);
    try {
      const responses = await Promise.all(
        plants.map(plant =>
          axios
            .post('/api/powermetercompare', { plant })
            .then(res => ({
              plant,
              value: res.data.LifetimeTotalPower,
              time: res.data.time
            }))
        )
      );

      const displayNames = {
        Sweelee: "Huawei Datalogger",
        SLS: "Trek Secure Datalogger",
      };

      const colorMap = {
        "Huawei Datalogger": "#8B0000",
        "Trek Secure Datalogger": "#003366"
      };

      const chartData = responses.map(r => {
        const name = displayNames[r.plant] || r.plant;
        return {
          name,
          value: r.value || 0,
          fill: colorMap[name] || "#8884d8",
          time: formatDateTime(r.time)
        };
      });

      setLatestData(chartData);
    } catch (error) {
      console.error('Error fetching latest power readings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLatestData(); 
  }, []);

  const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const { value, time } = payload[0].payload;
    return (
      <div style={{
        backgroundColor: 'white',
        border: '1px solid #ccc',
        padding: '10px',
        borderRadius: '6px'
      }}>
        <p><strong>{label}</strong></p>
        <p>Total Energy: {value} MWh</p>
        <p>Last Updated: {time}</p>
      </div>
    );
  }
  return null;
};


  return (
    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center',backgroundColor:"white" }}>
      <h5 className="text-lg font-bold mb-6 text-center">
        PowerMeter Latest Reading Comparison (Huawei vs Trek Datalogger)
      </h5>

      {loading ? (
        <p>Loading chart...</p>
      ) : (
        <>
          <div style={{ width: '80%' }}>
            <ResponsiveContainer width="90%" height={350}>
              <BarChart data={latestData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis label={{ value:'Total Energy (MWh)', angle: -90, position: 'insideLeft' }} />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Bar dataKey="value" name="Total PowerMeter Energy">
                  {latestData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>

        {/* <div style={{ marginTop: '16px', textAlign: 'center' }}>
  {latestData.map((entry, idx) => (
    <div key={idx}>
      <strong>{entry.name}</strong>: Last Updated at <span>{entry.time}</span>
    </div>
  ))}
</div> */}
  
        
        </>
      )}
    </div>
  );
};

export default DayWisePowerSensorChart;
